<div hidden>
    <ng-template #loadingSpinner>
        <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
    </ng-template>
</div>
<p-popover #op>
    eFAACT Guide
</p-popover>

<div class="card scroll-container" fullscreen>
    <h2>
        <a href="javascript:;" (click)="op.show($event)"> My eFAACT Guide </a>
    </h2>
    <!--main content-->
    <div class="sticky-table-container">
        <p-table stripedRows #dtGuide
            *ngIf="rowGroupMetadata; else loadingSpinner"
            [value]="processesCategories"
            tableStyleClass="table p-datatable-full"
            dataKey="ProcessID"
            [globalFilterFields]="['ProcessName']"
            (onFilter)="onFilter($event)"
            (onSort)="onSort($event)"
            (sortFunction)="customSort($event)"
            [customSort]="true"
            [rowHover]="true"
        >
            <ng-template pTemplate="header" let-item>
                <tr>
                    <th style="width: 10rem">
                        <div class="tabulator-col-content">
                            <div class="tabulator-col-title">Category</div>
                            <p-sortIcon
                                pSortableColumn="CategoryName"
                                field="CategoryName"
                                ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"
                            ></p-sortIcon>
                        </div>
                    </th>
                    <th style="min-width: 20rem">
                        <div class="tabulator-col-content">
                            <div class="tabulator-col-title">Process</div>
                            <p-sortIcon
                                pSortableColumn="ProcessTitle"
                                field="ProcessTitle"
                                ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"
                            ></p-sortIcon>
                        </div>
                    </th>
                    <th *ngIf="hasDemo()">Demo</th>
                    <th *ngIf="hasDocumentation()">Documentation</th>
                    <th *ngIf="hasTraining()">Training</th>
                </tr>
                <tr>
                    <th>
                        <div class="tabulator-header-filter">
                            <div class="input-group input-group-after">
                                <input
                                    #categoryFilter
                                    pInputText
                                    placeholder="Filter"
                                    (input)="
                                        dtGuide.filter(
                                            $event.target.value,
                                            'CategoryName',
                                            'contains'
                                        )
                                    "
                                />
                                <div
                                    class="input-group-append"
                                    style="height: 1.5rem"
                                >
                                    <span
                                        class="input-group-text"
                                        style="cursor: pointer"
                                        (click)="
                                            categoryFilter.value = '';
                                            dtGuide.filter(
                                                '',
                                                'CategoryName',
                                                'contains'
                                            )
                                        "
                                    >
                                        <i class="fa fa-times"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th>
                        <div class="tabulator-header-filter">
                            <div class="input-group input-group-after">
                                <input
                                    #processFilter
                                    pInputText
                                    placeholder="Filter"
                                    (input)="
                                        dtGuide.filter(
                                            $event.target.value,
                                            'ProcessTitle',
                                            'contains'
                                        )
                                    "
                                />
                                <div
                                    class="input-group-append"
                                    style="height: 1.5rem"
                                >
                                    <span
                                        class="input-group-text"
                                        style="cursor: pointer"
                                        (click)="
                                            processFilter.value = '';
                                            dtGuide.filter(
                                                '',
                                                'ProcessTitle',
                                                'contains'
                                            )
                                        "
                                    >
                                        <i class="fa fa-times"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th *ngIf="hasDemo()"></th>
                    <th *ngIf="hasDocumentation()"></th>
                    <th *ngIf="hasTraining()"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-ri="rowIndex">
                <tr class="p-datatable-row">
                    <td
                        class="p-datatable-cell"
                        *ngIf="rowGroupMetadata[item.CategoryId].index === ri"
                        [attr.rowspan]="rowGroupMetadata[item.CategoryId].size"
                    >
                        {{ item.CategoryName }}
                    </td>
                    <td class="p-datatable-cell">{{ item.ProcessTitle }}</td>
                    <td *ngIf="hasDemo()" class="p-datatable-cell">
                        <a
                            *ngIf="item.UrlDemo"
                            style="font-size: 2em"
                            data-toggle="tooltip"
                            data-placement="top"
                            [href]="item.UrlDemo"
                            target="_blank"
                        >
                            <i class="pi pi-video"></i>
                        </a>
                    </td>
                    <td *ngIf="hasDocumentation()" class="p-datatable-cell">
                        <a
                            *ngIf="item.UrlDocumentation"
                            style="font-size: 2em"
                            data-toggle="tooltip"
                            data-placement="top"
                            [href]="item.UrlDocumentation"
                            target="_blank"
                        >
                            <i class="pi pi-file-pdf"></i>
                        </a>
                    </td>
                    <td *ngIf="hasTraining()" class="p-datatable-cell">
                        <a
                            *ngIf="item.UrlTraining"
                            style="font-size: 2em"
                            data-toggle="tooltip"
                            data-placement="top"
                            [href]="item.UrlTraining"
                            target="_blank"
                        >
                            <i class="pi pi-users"></i>
                        </a>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
